module.exports = __webpack_public_path__ + "static/media/presentation-ipad.65615a83.jpg";